import * as c from "react";
import $ from "./useControlled.mjs";
import f from "./useEventCallback.mjs";
let V = !1;
function y({
  onChange: p,
  onViewChange: x,
  openTo: t,
  view: r,
  views: e,
  autoFocus: C,
  focusedView: M,
  onFocusedViewChange: O
}) {
  var b, h;
  process.env.NODE_ENV !== "production" && (V || (r != null && !e.includes(r) && (console.warn(`MUI: \`view="${r}"\` is not a valid prop.`, `It must be an element of \`views=["${e.join('", "')}"]\`.`), V = !0), r == null && t != null && !e.includes(t) && (console.warn(`MUI: \`openTo="${t}"\` is not a valid prop.`, `It must be an element of \`views=["${e.join('", "')}"]\`.`), V = !0)));
  const i = c.useRef(t), a = c.useRef(e), _ = c.useRef(e.includes(t) ? t : e[0]), [u, d] = $({
    name: "useViews",
    state: "view",
    controlled: r,
    default: _.current
  }), j = c.useRef(C ? u : null), [A, I] = $({
    name: "useViews",
    state: "focusedView",
    controlled: M,
    default: j.current
  });
  c.useEffect(() => {
    (i.current && i.current !== t || a.current && a.current.some((n) => !e.includes(n))) && (d(e.includes(t) ? t : e[0]), a.current = e, i.current = t);
  }, [t, d, u, e]);
  const N = e.indexOf(u), U = (b = e[N - 1]) != null ? b : null, o = (h = e[N + 1]) != null ? h : null, R = f((n, s) => {
    I(s ? n : (l) => n === l ? null : l), O?.(n, s);
  }), m = f((n) => {
    R(n, !0), n !== u && (d(n), x && x(n));
  }), g = f(() => {
    o && m(o);
  }), k = f((n, s, l) => {
    const E = s === "finish", B = l ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but we it's not the final view given all `views` -> overall selection state should be `partial`.
      e.indexOf(l) < e.length - 1
    ) : !!o;
    if (p(n, E && B ? "partial" : s, l), l && l !== u) {
      const S = e[e.indexOf(l) + 1];
      S && m(S);
    } else
      E && g();
  });
  return {
    view: u,
    setView: m,
    focusedView: A,
    setFocusedView: R,
    nextView: o,
    previousView: U,
    // Always return up to date default view instead of the initial one (i.e. defaultView.current)
    defaultView: e.includes(t) ? t : e[0],
    goToNextView: g,
    setValueAndGoToNextView: k
  };
}
export {
  y as useViews
};
//# sourceMappingURL=useViews.mjs.map
